<template>
  <!-- <div class="login">
        <div class="login-cont">
            <h4>运营通</h4>
            <el-input v-model="code" placeholder="请输入账号"></el-input>
            <el-input type="password" v-model="passWore" placeholder="请输入密码"></el-input>
            <el-button type="primary" style="width:100%;" :disabled="code == '' || passWore == '' " @click="loginClick()">确定</el-button>
        </div>
    </div> -->
  <div class="login">
    <img class="login_img" src="../../assets/img/login.png" alt="" />
    <div class="login-cont">
      <div class="title">运营通</div>
      <div class="login-wai">
        <div class="biao">账号密码登录</div>
        <el-input
          v-model="code"
          placeholder="请输入账号"
          @keyup.enter.native="enterClick()"
        ></el-input>
        <el-input
          type="password"
          v-model="passWore"
          placeholder="请输入密码"
          @keyup.enter.native="enterClick()"
        ></el-input>
        <el-button
          type="primary"
          style="width: 100%"
          :disabled="code == '' || passWore == ''"
          @click="loginClick()"
          >确定
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { loginApi } from "../../api/index";
import store from "../../store/index";
console.log(store);
export default {
  data() {
    return {
      code: "",
      passWore: "",
    };
  },
  created() {},
  methods: {
    loginClick() {
      loginApi({
        account: this.code,
        password: this.passWore,
      }).then((Er) => {
        if (Er.return_code == 200) {
            localStorage.setItem("Authorization", Er.data.authorization);
            localStorage.setItem("user_id", Er.data.user_id);
            localStorage.setItem("menu_list",  JSON.stringify(Er.data.menu_list));
            localStorage.setItem('brand_id',Er.data.brand_id)
            localStorage.setItem('store_list',JSON.stringify(Er.data.store_list))
            this.$message({
                message: "登陆成功",
                type: "success",
            });
            if(Er.data.menu_list && Er.data.menu_list.length>0){
              if(Er.data.menu_list[0].children.length>0){
                this.$router.push(Er.data.menu_list[0].children[0].path);
              }else{
                this.$router.push(Er.data.menu_list[0].path);
              }
            }
            
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  height: 100%;
  background: url(../../assets/img/log_bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .login_img {
    position: absolute;
    top: 60px;
    left: 60px;
    height: 40px;
    width: 114px;
  }
  .login-cont {
    width: 376px;
    .title {
      text-align: center;
      color: #fff;
      font-size: 48px;
      margin-bottom: 38px;
    }
    .login-wai {
      padding: 24px 48px 34px 48px;
      border-radius: 4px;
      line-height: 60px;
      background: #ffffff;
      box-shadow: 0px 6px 12px 0px rgba(62, 86, 110, 0.06);
      border-radius: 16px;
      border: 1px solid rgba(62, 86, 110, 0.1);
      .biao {
        color: rgba(62, 86, 110, 1);
        font-size: 24px;
        font-weight: 500;
      }
    }
  }
}
</style>
